import React, { useEffect } from 'react';
import styled from 'styled-components';

const CompletedContainer = styled.div`
  text-align: center;
  padding: 48px 16px;
`;

const CompletedIcon = styled.div`
  font-size: 64px;
  margin-bottom: 24px;
`;

const CompletedTitle = styled.h2`
  margin: 0 0 16px 0;
  font-size: 24px;
  font-weight: 600;
  color: var(--tg-theme-text-color, #000000);
`;

const CompletedText = styled.p`
  margin: 0 0 24px 0;
  font-size: 16px;
  color: var(--tg-theme-hint-color, #999999);
  line-height: 1.5;
`;

const CloseButton = styled.button`
  padding: 16px 24px;
  background-color: var(--tg-theme-button-color, #2481cc);
  color: var(--tg-theme-button-text-color, #ffffff);
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s ease;
  
  &:hover {
    opacity: 0.9;
  }
`;

const CloseNote = styled.p`
  margin: 16px 0 0 0;
  font-size: 14px;
  color: var(--tg-theme-hint-color, #999999);
  font-style: italic;
`;

function AlreadyCompletedMessage({ quizName }) {
  const handleClose = () => {
    if (window.Telegram?.WebApp) {
      window.Telegram.WebApp.close();
    } else {
      // Для тестирования без Telegram
      window.close();
    }
  };

  // Автоматически закрыть через 5 секунд
  useEffect(() => {
    const timer = setTimeout(() => {
      handleClose();
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <CompletedContainer>
      <CompletedIcon>✅</CompletedIcon>
      <CompletedTitle>Опрос уже пройден</CompletedTitle>
      <CompletedText>
        {quizName ? (
          <>
            Вы уже проходили опрос<br />
            "<strong>{quizName}</strong>"
          </>
        ) : (
          'Вы уже проходили этот опрос'
        )}
        <br /><br />
        Спасибо за участие!
      </CompletedText>
      <CloseButton onClick={handleClose}>
        Закрыть
      </CloseButton>
      <CloseNote>
        Приложение автоматически закроется через несколько секунд...
      </CloseNote>
    </CompletedContainer>
  );
}

export default AlreadyCompletedMessage; 